module.exports = __webpack_public_path__ + "images/help/logo-small@2x-913d822d6b370c102882a908a472cda4.png";